export const walletsFeaturesMap = {
  aiOverview: 'ai_overview',
  aiDraft: 'ai_draft',
}
